export const createMockableState = (state) => ({
  // to test components Loaded with mocked data
  isMocked: false,
  // to test components Loaded with data from API
  // isMocked: false,

  ...state
})
